module.exports = __webpack_public_path__ + "static/media/Debts2.9fe93939.png";